import { FC } from "react";
import { AxiosError } from "axios";
import { RefetchOptions } from "@tanstack/react-query";

import {
  BusinessError,
  BackendNotFoundError,
  UnauthorizedError,
  BackendTimeoutError,
  AccessForbiddenError,
  FrontendTimeoutError,
  BackendUnexpectedError,
  ServerUnavailableError,
} from "./components";
import { axiosInstance } from "../../../api/axiosConfig";

export interface IErrorComponent {
  error: Error | null;
  refetch?: (options?: RefetchOptions | undefined) => Promise<unknown>;
  techInfoBgColor?: "white" | "gray";
  showGoHomeButton?: boolean;
}

export const ErrorComponent: FC<IErrorComponent> = (props) => {
  const { error } = props;

  const frontedTimeoutMessage = `timeout of ${axiosInstance.defaults.timeout}ms exceeded`;
  const httpStatusCode = (error as AxiosError | null)?.status;

  if (error?.message === frontedTimeoutMessage) {
    return <FrontendTimeoutError {...props} />;
  }

  switch (httpStatusCode) {
    case 401: {
      return <UnauthorizedError {...props} />;
    }
    case 403: {
      return <AccessForbiddenError {...props} />;
    }
    case 404: {
      return <BackendNotFoundError {...props} />;
    }
    case 461: {
      return <BusinessError {...props} />;
    }
    case 502:
    case 503: {
      return <ServerUnavailableError {...props} />;
    }
    case 504: {
      return <BackendTimeoutError {...props} />;
    }
    default: {
      return <BackendUnexpectedError {...props} />;
    }
  }
};
